import { useState } from "react";
import { topCompanies } from "../imageLinks";
import Modal from "./Modal";
import PricingCard from "./PricingCard";
import Accordian from "./Accordian";
import Slider from "react-slick";
import { workAtsettings } from "../../HomePage/constants";
import { IKImage } from "imagekitio-react";
import { useEffect } from "react";
import {
  createLeadScore,
  getPricingGoal,
  getProductPricing,
  getUserStoriesAndReviews,
} from "../../../redux/actions/pricing";
import { useDispatch } from "react-redux";
import { getFaqData } from "../../../redux/actions/pricing";
import Review from "./Review";
import { useSelector } from "react-redux";
import {
  getReviewData,
  getToggleDiscount,
  getBookingProduct,
  getProductById,
} from "../../../redux/actions/pricing";
import { getEpsFormData } from "../../../redux/actions/jobEligibilityScore";
import { setEpsData } from "../../../redux/actions/userActivity";
import { useRef } from "react";
import Timer from "../Timer";
import Switch from "../Switch";
import PricingMonthlyCard from "../PricingMonthly/PricingMonthlyCard";
import EligibilityLoader from "./EligibilityLoader";
import EligibleModal from "./EligibleModal";
import NonEligibleModal from "./NonEligibleModal";
import CompletionModal from "../CompletionModal";
import CheckEligibilityModal from "./CheckEligibilityModal";
import Constants, { leadScoringActivity } from "../../../common/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendDown,
  faPhone,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { faCloudArrowDown } from "@fortawesome/free-solid-svg-icons";
import { Mixpanel } from "../../../config/Mixpanel";
// import PricingFooter from "../PricingFooter";
import PricingNavbar from "../PricingNavbar";
import { useInRouterContext, useSearchParams } from "react-router-dom";
import DowngradeModal from "../DowngradeModal";
import ExitPopUp from "../ExitPopUp";
import PlanInformation from "./PlanInformation";
import Spinner from "../../../components/Spinner";
import StickySection from "./StickySection";
import "./index.css";

// import OurLearnersWorkAt from "../../../components/Carousel";

import CareerModal from "./CareerModal";
import PricingHeader from "./PricingHeader";

// import BenefitsSection from "./BenefitsSection";

import HeroSection from "./HeroSection";
// import AchievementSection from "./AchievementSection";
// import BeTheWinner from "../BeTheWinner";
import ProductAnnualModal from "./ProductAnnualModal";
// import WithoutSection from "./WithoutSection";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "../pricingslider.css";
import { Suspense } from "react";
import LazySpinner from "../../../components/LazySpinner";
import { lazy } from "react";
const BenefitsSection = lazy(() => import("./BenefitsSection"));
const AchievementSection = lazy(() => import("./AchievementSection"));
const OurLearnersWorkAt = lazy(() => import("../../../components/Carousel"));
const WithoutSection = lazy(() => import("./WithoutSection"));
const BeTheWinner = lazy(() => import("../BeTheWinner"));
const Senja = lazy(() => import("./Senja"));
const PricingFooter = lazy(() => import("../PricingFooter"));

const PricingAnnual = ({
  product_type,
  discountTime,
  subscription_type,
  razorpayHandler,
  thankyou,
  route,
  scrollToMax,
  scrollToProMonthly,
  setScrollToProMonthly,
  isCareerGoal,
  setIsCareerGoal,
  userToggle,
}) => {
  const [activePricingId, setActivePricingId] = useState(3);
  const [activeOddUserPricingId, setActiveOddUserPricingId] = useState(3);
  const [isHelp, setIsHelp] = useState(false);
  const [cardDatas, setCardDatas] = useState([]);
  const [faqDatas, setFaqDatas] = useState([]);
  const [seeDetails, setSeeDetails] = useState(false);
  const [reviewDatas, setReviewDatas] = useState([]);
  const dispatch = useDispatch();
  const userSubscription = useSelector((store) => store?.userSubscription);
  const authentication = useSelector((store) => store?.authentication);
  const [cardMonthlyDatas, setCardMonthlyDatas] = useState([]);
  const [isDiscount, setIsDiscount] = useState(true);
  const [isToggle, setIsToggle] = useState(false);
  const [isEligibiltyLoader, setIsEligibilityLoader] = useState(false);
  const [isEligibleModalEnabled, setIsEligibleModalEnabled] = useState(false);
  const [isnotEligibleModalEnabled, setIsNotEligibleModalEnabled] =
    useState(false);
  const [isCompletionModal, setIsCompletionModal] = useState(
    thankyou === "true" ? true : false,
  );
  const [isCheckModal, setIsCheckModal] = useState(false);
  const [bookingProduct, setBookingProduct] = useState({ cost: 0 });
  const [proPlusData, setProPlusData] = useState([]);
  const [downgradeModal, setDowngradeModal] = useState(false);
  const [exitModal, setExitModal] = useState(false);
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const email = useSelector((store) => store?.profileDetails?.email);
  const [searchParams, setSearchParams] = useSearchParams();
  const [pricingSpinner, setPricingSpinner] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [showStickyBar, setShowStickeyBar] = useState(false);
  const user_role = useSelector((store) => store?.userSubscription?.user_role);
  const isBlocked = useSelector(
    (store) => store?.userActivity?.user_trial_blocked,
  );
  const [isCareerModalEnabled, setIsCareerModalEnabled] = useState(false);
  const [activePlan, setActivePlan] = useState({
    plan_name: "Free",
    plan_image: "",
  });
  const [userStoriesAndReviews, setUserStoriesAndReviews] = useState([]);
  const mainRef = useRef();
  const isEligible = useSelector(
    (store) => store?.userSubscription?.isEligibleForLearntubeMax,
  );

  // const [isCareerGoal, setIsCareerGoal] = useState({
  //   is_show: true,
  //   selected_goal: { goal_name: "Certifications", product: "LearnTube Pro" },
  // });
  const [activeChildProduct, setActiveChildProduct] = useState({
    cost_details: {
      final_cost: 0,
      original_cost: 0,
      monthly_cost: 0,
    },
  });
  const [activeChildButton, setActiveChildButton] = useState({
    first: {},
    second: {},
  });

  const [activeCard, setActiveCard] = useState([]);
  const [activeChildProduct1, setActiveChildProduct1] = useState({
    cost_details: {
      final_cost: 0,
      original_cost: 0,
      monthly_cost: 0,
    },
  });
  const [activeChildButton1, setActiveChildButton1] = useState({
    first: {},
    second: {},
  });

  const [dummyNumber, setDummyNumber] = useState(98);
  const [isSelected, setIsSelected] = useState(false);
  const [defaultState, setDefaultState] = useState(false);
  const [defaultSticky, setDefaultSticky] = useState({
    first: {},
    second: {},
  });

  useEffect(() => {
    dispatch(
      getProductPricing(user_id, (successObj) => {
        setCardDatas(successObj);
        setPricingSpinner(false);

        const defaultActivePlan = successObj?.filter(
          (item) => item?.is_active_plan === true,
        );
        if (defaultActivePlan?.length > 0) {
          setDefaultState(true);
        } else if (user_role === 1) {
          setDefaultState(true);
        }
      }),
    );

    dispatch(
      getBookingProduct((successObj) => {
        setBookingProduct(successObj);
      }),
    );

    dispatch(
      getFaqData((successObj) => {
        setFaqDatas(successObj);
      }),
    );

    dispatch(
      getReviewData((successObj) => {
        setReviewDatas(successObj);
      }),
    );

    dispatch(
      getEpsFormData(user_id, (successObj) => {
        dispatch(setEpsData(successObj));
      }),
    );

    dispatch(
      getUserStoriesAndReviews(
        (successObj) => {
          setUserStoriesAndReviews(successObj);
        },
        (errObj) => {},
      ),
    );
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setDummyNumber((prev) => prev + 1);

      if (dummyNumber > 200) {
        clearInterval(interval);
      }
    }, 120000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    function handleScroll() {
      const currentScrollPos = window.pageYOffset;
      const isScrollingUp = currentScrollPos < prevScrollPos;

      if (isScrollingUp) {
        setShowStickeyBar(false);
      } else {
        setShowStickeyBar(true);
      }

      setPrevScrollPos(currentScrollPos);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);

  useEffect(() => {
    if (userSubscription?.user_role === 3) {
      dispatch(
        getProductById(
          2,
          (successObj) => {
            setProPlusData(successObj);
          },
          (err) => {},
        ),
      );
    }
  }, [userSubscription?.user_role]);

  useEffect(() => {
    if (isCareerGoal?.is_show) {
      const plan = cardDatas?.filter(
        (data) => data?.plan_name === isCareerGoal?.selected_goal?.product,
      );
      setActivePlan(plan?.[0]);
    } else {
      const plan = cardDatas?.filter((data) => data?.is_active_plan === true);
      if (plan?.length === 0) {
        setActivePlan(cardDatas?.[3]);
        console.log(plan, "1");
      } else {
        setActivePlan(plan?.[0]);
        console.log(plan, "2");
      }
    }
  }, [cardDatas, isCareerGoal]);

  useEffect(() => {
    if (isCareerGoal?.is_show) {
      switch (isCareerGoal?.selected_goal?.product) {
        case "LearnTube Pro": {
          setActiveCard(cardDatas?.[0]);
          console.log("shown_pro");
          break;
        }
        case "LearnTubeX": {
          console.log("shown_x");
          setActiveCard(cardDatas?.[1]);
          break;
        }
        case "LearnTube Max": {
          console.log("shown_max");
          setActiveCard(cardDatas?.[2]);
          break;
        }

        default:
          break;
      }
    } else {
      switch (user_role) {
        case 1:
          return setActiveCard(cardDatas?.[0]);
        case 2:
          return setActiveCard(cardDatas?.[1]);
        case 4:
          return setActiveCard(cardDatas?.[2]);
        case 6:
          return setActiveCard(cardDatas?.[2]);

        default:
          break;
      }
    }
  }, [cardDatas, isCareerGoal]);

  console.log("new pricing", isCareerGoal);
  // console.log({ cardDatas })
  const sliderSettings = {
    dots: false,
    slidesToShow: 7,
    rows: 1,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 2000,
    easing: "linear",
    cssEase: "linear",
    infinite: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3.75,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          infinite: true,
          dots: false,
          arrows: false,
          swipeToSlide: true,
        },
      },
    ],
  };
  const settings = {
    dots: false,
    slidesToShow: 4,
    rows: 1,
    speed: 300,
    cssEase: "linear",
    infinite: false,
    dots: false,
    arrows: false,
    swipeToSlide: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3.2,
          infinite: false,
          dots: false,
          arrows: false,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 370,
        settings: {
          slidesToShow: 3.05,
          infinite: false,
          dots: false,
          arrows: false,
          swipeToSlide: true,
        },
      },
    ],
  };

  const reviewsettings1 = {
    dots: false,
    slidesToShow: 2,
    rows: 1,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    easing: "linear",
    cssEase: "linear",
    infinite: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          infinite: false,
          dots: false,
          arrows: false,
          swipeToSlide: true,
        },
      },
    ],
  };

  const reviewsettings = {
    dots: false,
    slidesToShow: 3,
    rows: 1,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    easing: "linear",
    cssEase: "linear",
    infinite: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          infinite: false,
          dots: false,
          arrows: false,
          swipeToSlide: true,
        },
      },
    ],
  };
  console.log("odduser", activeOddUserPricingId);
  return (
    <div
      className="flex w-full flex-col items-center bg-[#F5FEFF] "
      ref={mainRef}
    >
      {!userToggle ? (
        <>
          <PricingNavbar
            route={route}
            setExitModal={setExitModal}
            userToggle={userToggle}
            isCareerGoal={isCareerGoal}
            setIsCareerGoal={setIsCareerGoal}
            defaultState={defaultState}
          />
          {pricingSpinner ? (
            <Spinner />
          ) : (
            <PricingHeader
              activePlan={activePlan}
              isCareerGoal={isCareerGoal}
              cardDatas={cardDatas}
              setIsCareerModalEnabled={setIsCareerModalEnabled}
              setSeeDetails={setSeeDetails}
              razorpayHandler={razorpayHandler}
            />
          )}

          <HeroSection
            isCareerGoal={isCareerGoal}
            cardDatas={cardDatas}
            reviews={userStoriesAndReviews?.data?.featured_reviews}
          />
          <Suspense fallback={LazySpinner}>
            {" "}
            <BenefitsSection activeCard={activeCard} />
          </Suspense>
          <Suspense fallback={LazySpinner}>
            {" "}
            <AchievementSection
              achievements={userStoriesAndReviews?.data?.success_stories}
            />
          </Suspense>

          <div className="flex w-full  flex-col items-center justify-center bg-[#F5FEFF]">
            <h2 className=" mt-[32px] whitespace-nowrap text-[18px] font-medium text-[#086788] md:text-[24px] ">
              Our Learners Work At
            </h2>
            <div className="mt-2 flex w-10/12 flex-col items-center justify-center md:mt-4 md:w-11/12 xl:w-7/12">
              <Suspense fallback={LazySpinner}>
                {" "}
                <OurLearnersWorkAt />
              </Suspense>
            </div>
          </div>
          <Suspense fallback={LazySpinner}>
            {" "}
            <WithoutSection activeCard={activeCard} />
          </Suspense>
          <Suspense fallback={LazySpinner}>
            {" "}
            <BeTheWinner
              activeCard={activeCard}
              activeChildProduct={activeChildProduct1}
              setActiveChildProduct={setActiveChildProduct1}
              activeChildButton={activeChildButton1}
              setActiveChildButton={setActiveChildButton1}
              bookingProduct={bookingProduct}
              razorpayHandler={razorpayHandler}
              setDowngradeModal={setDowngradeModal}
              setIsCheckModal={setIsCheckModal}
              proPlusData={proPlusData}
            />
          </Suspense>

          {authentication !== null && (
            <Timer
              countDownDate={discountTime}
              type="annual"
              setIsDiscount={setIsDiscount}
              isToggle={isToggle}
              userToggle={userToggle}
            />
          )}
          {isCareerModalEnabled && (
            <CareerModal
              isModalEnabled={isCareerModalEnabled}
              setIsModalEnabled={setIsCareerModalEnabled}
              setIsCareerGoal={setIsCareerGoal}
            />
          )}
          {seeDetails && (
            <ProductAnnualModal
              activeCard={activePlan}
              isModalEnabled={seeDetails}
              setIsModalEnabled={setSeeDetails}
              proPlusData={proPlusData}
              bookingProduct={bookingProduct}
            />
          )}

          {pricingSpinner ? (
            <Spinner />
          ) : (
            <div className="w-full flex-col items-center justify-center px-2 py-2 md:w-7/12 md:px-0">
              <div className="havegoal-background-gradient mt-4 rounded-lg py-2 md:py-4">
                <div className="px-4">
                  <div className="text-[18px] font-semibold text-white md:text-[26px]">
                    {" "}
                    Have a different goal? Explore all our Plans.
                  </div>
                </div>
                <div className=" pricingCorousel mt-2 ml-1 w-full md:mt-4 md:ml-2">
                  <Slider {...settings}>
                    {cardDatas?.length > 0 &&
                      cardDatas?.map((cardData, index) => (
                        <PricingCard
                          cardData={cardData}
                          id={index + 1}
                          activePricingId={activePricingId}
                          isCardEnabled={activePricingId === index + 1}
                          setIsCardEnabled={setActivePricingId}
                          section={searchParams.get("section")}
                          scrollToMax={scrollToMax}
                          isSelected={isSelected}
                          setIsSelected={setIsSelected}
                        ></PricingCard>
                      ))}
                  </Slider>
                  {/* {
                      cardDatas.map((cardData,index) => )
                  } */}
                </div>
                {isSelected && (
                  <div className="w-full px-2 md:px-0">
                    <PlanInformation
                      activeCard={cardDatas?.[activePricingId - 1]}
                      activeChildProduct={activeChildProduct}
                      setActiveChildProduct={setActiveChildProduct}
                      activeChildButton={activeChildButton}
                      setActiveChildButton={setActiveChildButton}
                      bookingProduct={bookingProduct}
                      razorpayHandler={razorpayHandler}
                      setDowngradeModal={setDowngradeModal}
                      setIsCheckModal={setIsCheckModal}
                      proPlusData={proPlusData}
                      setIsCareerGoal={setIsCareerGoal}
                      mainRef={mainRef}
                      userToggle={userToggle}
                      setActiveOddUserPricingId={setActiveOddUserPricingId}
                      maxData={cardDatas?.[2]}
                      setDefaultSticky={setDefaultSticky}
                    />
                  </div>
                )}
              </div>
              {isSelected && (
                <div className="flex w-full flex-col items-center justify-center">
                  <div className="text-md mt-4 text-center font-medium text-pricing_blue md:mt-6 md:text-[24px]">
                    Compare Plans
                  </div>
                  <img
                    urlEndpoint="https://img.learntube.ai/public-assets/"
                    src={
                      window.innerWidth > 760
                        ? "https://img.learntube.ai/public-assets/PRICING/compare-plan-desktop.svg?updatedAt=1686990623115"
                        : "https://img.learntube.ai/public-assets/PRICING/compare-plan.svg?updatedAt=1686990623111"
                    }
                    className="mt-0 w-full self-center md:mt-4 md:w-full"
                  />
                </div>
              )}
            </div>
          )}

          {isEligibiltyLoader && (
            <EligibilityLoader
              isModalEnabled={isEligibiltyLoader}
              setIsModalEnabled={setIsEligibilityLoader}
            ></EligibilityLoader>
          )}
          {isEligibleModalEnabled && (
            <EligibleModal
              isModalEnabled={isEligibleModalEnabled}
              setIsModalEnabled={setIsEligibleModalEnabled}
              razorpayHandler={razorpayHandler}
              cardData={cardDatas?.[2]?.plan_products?.[0]}
            ></EligibleModal>
          )}
          {isnotEligibleModalEnabled && (
            <NonEligibleModal
              isModalEnabled={isnotEligibleModalEnabled}
              setIsModalEnabled={setIsNotEligibleModalEnabled}
            ></NonEligibleModal>
          )}
          {isCompletionModal && (
            <CompletionModal
              isModalEnabled={isCompletionModal}
              setIsModalEnabled={setIsCompletionModal}
            ></CompletionModal>
          )}
          {isCheckModal && (
            <CheckEligibilityModal
              isModalEnabled={isCheckModal}
              setIsModalEnabled={setIsCheckModal}
              setIsEligibilityLoader={setIsEligibilityLoader}
              setIsEligibleModalEnabled={setIsEligibleModalEnabled}
              setIsNotEligibleModalEnabled={setIsNotEligibleModalEnabled}
            >
              {" "}
            </CheckEligibilityModal>
          )}
          {downgradeModal && (
            <DowngradeModal
              setIsModalEnabled={setDowngradeModal}
              setScrollToProMonthly={setScrollToProMonthly}
              setIsToggle={setIsToggle}
              setActivePricingId={setActivePricingId}
            />
          )}
          {exitModal && (
            <ExitPopUp
              isModalEnabled={exitModal}
              setIsModalEnabled={setExitModal}
              setDowngradeModal={setDowngradeModal}
              countDownDate={discountTime}
              setIsDiscount={setIsDiscount}
            />
          )}
          <div className=" mt-10 w-full bg-[#C2F0FF] py-2 text-center text-[20px] font-semibold text-[#086788] md:w-7/12  md:text-[32px]">
            Reviews and FAQs
          </div>
          <div className="mt-10 self-center text-[18px] font-medium text-pricing_blue md:text-[24px]">
            Reviews from our users
          </div>
          <div className=" pricing-scroll mt-4 w-full px-2 md:mt-4   md:w-7/12 md:px-0 ">
            {reviewDatas?.length > 0 && (
              <Slider {...reviewsettings1}>
                {reviewDatas?.map((reviewData) => (
                  <Review reviewData={reviewData}></Review>
                ))}
              </Slider>
            )}
          </div>
          <div className="mt-4 self-center text-[18px] font-medium  text-pricing_blue md:mt-10 md:text-[24px]">
            FAQs
          </div>
          <div className="mt-2 flex w-full flex-col rounded-2xl px-2 md:mt-4  md:w-7/12 md:px-0   ">
            {faqDatas.map(({ question, answer }, index) => (
              <Accordian
                title={question}
                content={answer}
                index={index}
                length={faqDatas?.length}
              ></Accordian>
            ))}
          </div>
          <div className=" mt-10 w-full bg-[#C2F0FF] py-2 text-center text-[20px] font-semibold text-[#086788] md:w-7/12 md:text-[32px]">
            Our Learners Really Love Us
          </div>
          <Suspense fallback={LazySpinner}>
            {" "}
            <Senja />
          </Suspense>
          <Suspense fallback={LazySpinner}>
            {" "}
            <PricingFooter />
          </Suspense>
          {showStickyBar &&
            cardDatas?.[activePricingId - 1]?.is_active_plan === false && (
              <StickySection
                activeChildProduct={activeChildProduct}
                activeChildButton={activeChildButton}
                activeCard={cardDatas?.[activePricingId - 1]}
                dummyNumber={dummyNumber}
                razorpayHandler={razorpayHandler}
                setDowngradeModal={setDowngradeModal}
                setIsCheckModal={setIsCheckModal}
                proData={cardDatas?.[0]}
                maxData={cardDatas?.[2]}
                countDownDate={discountTime}
                setIsDiscount={setIsDiscount}
                cardDatas={cardDatas}
                defaultSticky={defaultSticky}
                setDefaultSticky={setDefaultSticky}
              />
            )}
        </>
      ) : (
        <>
          <PricingNavbar
            route={route}
            setExitModal={setExitModal}
            userToggle={userToggle}
          />
          <div className="w-full  self-center md:h-auto md:w-3/5">
            <img
              urlEndpoint="https://img.learntube.ai/public-assets/"
              src={
                window.innerHeight > 500
                  ? "https://img.learntube.ai/public-assets/PRICING/banner__1_.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1678103215899"
                  : "https://img.learntube.ai/public-assets/PRICING/image.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1677559989880"
              }
              className="mt-0 w-full md:mt-4"
            />
          </div>
          <div className="mt-5 flex w-full  flex-col items-center justify-center  ">
            <h1 className="text-center text-xl font-medium md:mb-1 md:text-3xl  lg:text-4xl">
              Upgrade your Career with LearnTube.
            </h1>
            <h2 className="  w-full  text-center text-sm  font-semibold leading-tight text-[#737373] md:text-3xl md:font-medium lg:text-2xl">
              87% users achieve their goals in less than 6 months!
            </h2>
          </div>

          {pricingSpinner ? (
            <Spinner />
          ) : (
            <>
              <div className=" mt-5 mb-10 flex w-full grow flex-row items-center justify-center md:mt-10 md:mb-0 md:w-9/12">
                {cardDatas?.map((cardData, index) => (
                  <>
                    {index != cardDatas?.length - 1 && (
                      <div
                        className={` border-1 relative flex cursor-pointer  flex-col  items-center  justify-center  shadow-lg ${
                          activeOddUserPricingId === index + 1
                            ? "text-white"
                            : "text-black"
                        }  ${
                          window.innerWidth <= 370
                            ? "ml-1 mr-1 w-[112px] rounded-lg  border-[#979797]  px-2 py-3"
                            : "ml-2 mr-2 w-[112px] rounded-lg border-[#979797] px-2 py-3  md:mr-6  md:ml-6 md:w-[22%]  md:px-4 md:py-4"
                        }`}
                        onClick={(event) => {
                          setActiveOddUserPricingId(index + 1);
                          // createLeads(cardData);
                          if (cardData?.plan_name === "LearnTube Pro") {
                            setIsCareerGoal((prev) => ({
                              ...prev,
                              is_show: true,
                              selected_goal: {
                                goal_name: "Certifications",
                                product: "LearnTube Pro",
                                product_plans_id: 1,
                              },
                            }));
                          } else if (cardData?.plan_name === "LearnTubeX") {
                            setIsCareerGoal((prev) => ({
                              ...prev,
                              is_show: true,
                              selected_goal: {
                                goal_name: "Practical Learning",
                                product: "LearnTubeX",
                                product_plans_id: 4,
                              },
                            }));
                          } else {
                            setIsCareerGoal((prev) => ({
                              ...prev,
                              is_show: true,
                              selected_goal: {
                                goal_name: "Placements",
                                product: "LearnTube Max",
                                product_plans_id: 2,
                              },
                            }));
                          }
                        }}
                        style={{
                          background:
                            activeOddUserPricingId === index + 1
                              ? `linear-gradient(418deg, ${cardData?.plan_color_primary} 16.15%, ${cardData?.plan_color_secondary} 86.12%)`
                              : "white",
                        }}
                      >
                        {cardData?.is_active_plan ? (
                          <div className="absolute top-0 right-0 rounded-tr-lg rounded-bl-lg  bg-[#54D15A] p-[0.5px]  text-supertiny md:p-1 md:text-sm">
                            Plan Active
                          </div>
                        ) : cardData?.plan_name === "LearnTube Max" &&
                          user_role === 7 ? (
                          <div className="absolute top-0 right-0 rounded-tr-lg rounded-bl-lg bg-[#54D15A] p-[1.5px] text-supertiny md:text-sm">
                            Trial Active
                          </div>
                        ) : cardData?.plan_name === "Downgrade" &&
                          user_role === 1 &&
                          !isBlocked ? (
                          <div className="absolute top-0 right-0 rounded-tr-lg rounded-bl-lg bg-[#54D15A] p-[0.5px] text-supertiny md:p-1 md:text-xs">
                            Plan Active
                          </div>
                        ) : (
                          <></>
                        )}
                        <img
                          urlEndpoint="https://img.learntube.ai/public-assets/"
                          src={cardData?.plan_image}
                          className="h-6 w-6 md:h-7 md:w-7"
                        />
                        <div
                          className={
                            "whitspace-nowrap mt-1 text-xs font-medium md:text-sm"
                          }
                        >
                          {cardData?.plan_name}
                        </div>
                        <div className="text-xs font-medium md:text-sm">
                          For
                        </div>
                        <div className="whitespace-nowrap text-xs font-bold  md:text-[16px]">
                          {cardData?.plan_for}
                        </div>
                      </div>
                    )}
                  </>
                ))}
              </div>
            </>
          )}
          <HeroSection
            isCareerGoal={isCareerGoal}
            cardDatas={cardDatas}
            reviews={userStoriesAndReviews?.data?.featured_reviews}
          />
          <Suspense fallback={LazySpinner}>
            {" "}
            <BenefitsSection activeCard={activeCard} />
          </Suspense>
          <Suspense fallback={LazySpinner}>
            <AchievementSection
              achievements={userStoriesAndReviews?.data?.success_stories}
            />
          </Suspense>

          <div className="bg-blue-50 flex  w-full flex-col items-center justify-center">
            <h2 className=" mt-[32px] whitespace-nowrap text-[18px] font-medium text-[#086788] md:text-[24px] ">
              Our Learners Work At
            </h2>
            <div className="mt-2 flex w-10/12 flex-col items-center justify-center md:mt-4 md:w-11/12 xl:w-7/12">
              <Suspense fallback={LazySpinner}>
                {" "}
                <OurLearnersWorkAt />
              </Suspense>
            </div>
          </div>
          <Suspense fallback={LazySpinner}>
            {" "}
            <WithoutSection activeCard={activeCard} />
          </Suspense>
          <Suspense fallback={LazySpinner}>
            <BeTheWinner
              activeCard={activeCard}
              activeChildProduct={activeChildProduct1}
              setActiveChildProduct={setActiveChildProduct1}
              activeChildButton={activeChildButton1}
              setActiveChildButton={setActiveChildButton1}
              bookingProduct={bookingProduct}
              razorpayHandler={razorpayHandler}
              setDowngradeModal={setDowngradeModal}
              setIsCheckModal={setIsCheckModal}
              proPlusData={proPlusData}
            />
          </Suspense>

          {authentication !== null && (
            <Timer
              countDownDate={discountTime}
              type="annual"
              setIsDiscount={setIsDiscount}
              isToggle={isToggle}
              userToggle={userToggle}
            />
          )}
          {isCareerModalEnabled && (
            <CareerModal
              isModalEnabled={isCareerModalEnabled}
              setIsModalEnabled={setIsCareerModalEnabled}
              setIsCareerGoal={setIsCareerGoal}
            />
          )}
          {seeDetails && (
            <ProductAnnualModal
              activeCard={activePlan}
              isModalEnabled={seeDetails}
              setIsModalEnabled={setSeeDetails}
              proPlusData={proPlusData}
              bookingProduct={bookingProduct}
            />
          )}

          {pricingSpinner ? (
            <Spinner />
          ) : (
            <div className="w-full flex-col items-center justify-center px-2 py-2 md:w-7/12 md:px-0">
              <div className="havegoal-background-gradient mt-4 rounded-lg py-2 md:py-4">
                <div className="px-4">
                  <h1 className="text-[18px] font-semibold text-white md:text-[26px]">
                    {" "}
                    Have a different goal? Explore all our Plans.
                  </h1>
                </div>
                <div className=" pricingCorousel mt-2 ml-1 w-full md:mt-4 md:ml-2">
                  <Slider {...settings}>
                    {cardDatas?.length > 0 &&
                      cardDatas?.map((cardData, index) => (
                        <PricingCard
                          cardData={cardData}
                          id={index + 1}
                          activePricingId={activePricingId}
                          isCardEnabled={activePricingId === index + 1}
                          setIsCardEnabled={
                            userToggle
                              ? setActivePricingId
                              : setActiveOddUserPricingId
                          }
                          section={searchParams.get("section")}
                          scrollToMax={scrollToMax}
                          isSelected={isSelected}
                          setIsSelected={setIsSelected}
                        ></PricingCard>
                      ))}
                  </Slider>
                  {/* {
                      cardDatas.map((cardData,index) => )
                  } */}
                </div>
                {isSelected && (
                  <div className="w-full px-2 md:px-0">
                    <PlanInformation
                      activeCard={cardDatas?.[activePricingId - 1]}
                      activeChildProduct={activeChildProduct}
                      setActiveChildProduct={setActiveChildProduct}
                      activeChildButton={activeChildButton}
                      setActiveChildButton={setActiveChildButton}
                      bookingProduct={bookingProduct}
                      razorpayHandler={razorpayHandler}
                      setDowngradeModal={setDowngradeModal}
                      setIsCheckModal={setIsCheckModal}
                      proPlusData={proPlusData}
                      setIsCareerGoal={setIsCareerGoal}
                      mainRef={mainRef}
                      userToggle={userToggle}
                      setActiveOddUserPricingId={setActiveOddUserPricingId}
                      maxData={cardDatas?.[2]}
                      setDefaultSticky={setDefaultSticky}
                    />
                  </div>
                )}
              </div>
              {isSelected && (
                <div className="flex w-full flex-col items-center justify-center">
                  <div className="text-md mt-4 text-center font-medium text-pricing_blue md:mt-6 md:text-[24px]">
                    Compare Plans
                  </div>
                  <img
                    urlEndpoint="https://img.learntube.ai/public-assets/"
                    src={
                      window.innerWidth > 760
                        ? "https://img.learntube.ai/public-assets/PRICING/compare-plan-desktop.svg?updatedAt=1686990623115"
                        : "https://img.learntube.ai/public-assets/PRICING/compare-plan.svg?updatedAt=1686990623111"
                    }
                    className="mt-0 w-full self-center md:mt-4 md:w-full"
                  />
                </div>
              )}
            </div>
          )}

          {isEligibiltyLoader && (
            <EligibilityLoader
              isModalEnabled={isEligibiltyLoader}
              setIsModalEnabled={setIsEligibilityLoader}
            ></EligibilityLoader>
          )}
          {isEligibleModalEnabled && (
            <EligibleModal
              isModalEnabled={isEligibleModalEnabled}
              setIsModalEnabled={setIsEligibleModalEnabled}
              razorpayHandler={razorpayHandler}
              cardData={cardDatas?.[2]?.plan_products?.[0]}
            ></EligibleModal>
          )}
          {isnotEligibleModalEnabled && (
            <NonEligibleModal
              isModalEnabled={isnotEligibleModalEnabled}
              setIsModalEnabled={setIsNotEligibleModalEnabled}
            ></NonEligibleModal>
          )}
          {isCompletionModal && (
            <CompletionModal
              isModalEnabled={isCompletionModal}
              setIsModalEnabled={setIsCompletionModal}
            ></CompletionModal>
          )}
          {isCheckModal && (
            <CheckEligibilityModal
              isModalEnabled={isCheckModal}
              setIsModalEnabled={setIsCheckModal}
              setIsEligibilityLoader={setIsEligibilityLoader}
              setIsEligibleModalEnabled={setIsEligibleModalEnabled}
              setIsNotEligibleModalEnabled={setIsNotEligibleModalEnabled}
            >
              {" "}
            </CheckEligibilityModal>
          )}
          {downgradeModal && (
            <DowngradeModal
              setIsModalEnabled={setDowngradeModal}
              setScrollToProMonthly={setScrollToProMonthly}
              setIsToggle={setIsToggle}
              setActivePricingId={setActivePricingId}
            />
          )}
          {exitModal && (
            <ExitPopUp
              isModalEnabled={exitModal}
              setIsModalEnabled={setExitModal}
              setDowngradeModal={setDowngradeModal}
              countDownDate={discountTime}
              setIsDiscount={setIsDiscount}
            />
          )}
          <h1 className=" mt-10 w-full bg-[#C2F0FF] py-2 text-center text-[20px] font-semibold text-[#086788] md:w-7/12 md:text-[32px]">
            Reviews and FAQs
          </h1>
          <h2 className="mt-10 self-center text-[18px] font-medium text-pricing_blue md:text-[24px]">
            Reviews from our users
          </h2>
          <div className=" pricing-scroll mt-4 w-full px-2 md:mt-4   md:w-7/12 md:px-0 ">
            {reviewDatas?.length > 0 && (
              <Slider {...reviewsettings1}>
                {reviewDatas?.map((reviewData) => (
                  <Review reviewData={reviewData}></Review>
                ))}
              </Slider>
            )}
          </div>
          <h2 className="mt-4 self-center text-[18px] font-medium  text-pricing_blue md:mt-10 md:text-[24px]">
            FAQs
          </h2>
          <div className="mt-2 flex w-full flex-col rounded-2xl px-2 md:mt-4  md:w-7/12 md:px-0   ">
            {faqDatas.map(({ question, answer }, index) => (
              <Accordian
                title={question}
                content={answer}
                index={index}
                length={faqDatas?.length}
              ></Accordian>
            ))}
          </div>
          <h2 className=" mt-10 w-full bg-[#F5FEFF] py-2 text-center text-[20px] font-semibold text-[#086788] md:w-7/12 md:text-[32px]">
            Our Learners Really Love Us
          </h2>
          <Suspense fallback={LazySpinner}>
            {" "}
            <Senja />
          </Suspense>
          <Suspense fallback={LazySpinner}>
            {" "}
            <PricingFooter />
          </Suspense>
          {showStickyBar &&
            cardDatas?.[activePricingId - 1]?.is_active_plan === false && (
              <StickySection
                activeChildProduct={activeChildProduct}
                activeChildButton={activeChildButton}
                activeCard={cardDatas?.[activePricingId - 1]}
                dummyNumber={dummyNumber}
                razorpayHandler={razorpayHandler}
                setDowngradeModal={setDowngradeModal}
                setIsCheckModal={setIsCheckModal}
                proData={cardDatas?.[0]}
                maxData={cardDatas?.[2]}
                countDownDate={discountTime}
                setIsDiscount={setIsDiscount}
                cardDatas={cardDatas}
                defaultSticky={defaultSticky}
                setDefaultSticky={setDefaultSticky}
                key={isEligible}
              />
            )}
        </>
      )}
    </div>
  );
};

export default PricingAnnual;
